import { useAppDispatch } from "@/core/app/hooks"
import { UnderCutType } from "@/core/app/slices/user/user.type"
import { Box } from "@mui/material"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
export const DigitalFill = ({
  currPrint,
  updateModel,
}) => {
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()
  // checkbox if No UnderCut
  const [checkUnder, setCheckUnder] = useState<UnderCutType>(UnderCutType.No)
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value) as UnderCutType
    setCheckUnder(value)
    dispatch(updateModel({ UnderCut: value }))
  }

  useEffect(() => {
    if (currPrint?.UnderCut !== undefined) {
      setCheckUnder(currPrint?.UnderCut)
    }
  }, [currPrint?.UnderCut])
  return (
    <Box sx={{ width: "100%" }}>
      <FormControl>
        <FormLabel id="addUnderCut">
          {t("stlPrinting.addUndercutFilling")}
        </FormLabel>
        <RadioGroup
          row
          sx={{ marginLeft: "10px", gap: "40px" }}
          aria-labelledby="addUnderCut"
          name="radio-buttons-group"
          value={checkUnder}
          onChange={handleCheck}
        >
          <FormControlLabel
            value={UnderCutType.Yes}
            control={<Radio />}
            label={t(`stlPrinting.optionYes`)}
          />
          <FormControlLabel
            value={UnderCutType.No}
            control={<Radio />}
            label={t(`stlPrinting.optionNo`)}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  )
}
